export const subscriptionTypes = {
  SEC_OPS: 'SEC_OPS',
  FUSION: 'FUSION',
  DTM: 'DTM',
  VULN: 'VULN',
  EIB: 'EIB',
}

export default subscriptionTypes
